import { render } from "./RedirectPlayListGenero.vue?vue&type=template&id=608c157b"
import script from "./RedirectPlayListGenero.vue?vue&type=script&lang=js"
export * from "./RedirectPlayListGenero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__